(function($) {
	/*jshint validthis:true */
	"use strict";

	function showProperForms() {
		var id = $(this).attr('id');
		var ctn = $('.com-suggested-articles-admin__form[data-id="'+id+'"]');
		var parent = $(this).closest('.com-suggested-articles__admin');

		$('.com-suggested-articles-admin__form', parent).hide();
		if (ctn.length) {
			ctn.show();
		}
	}

	function saveProperties() {
		var settings = $(this).closest('.com-suggested-articles__admin');
		var lang = $('html').attr('lang');
		var checkedRadioBtn = $('input:checked', settings);
		var id = checkedRadioBtn.attr('id');
		var ctn = $('.com-suggested-articles-admin__form[data-id="'+id+'"]');
		var value = "";
		var key = $(this).attr('data-key');
		
		if (id.indexOf('custom') > -1) {
			value = "b:";
			$('.com-suggested-articles-delete-custom-btn', settings).each(function(i,el) {
				if (i != "0") {
					value += ",";
				}
				value += el.dataset.id;
			});
		} else if (id.indexOf('category') > -1) {
			value = "c:";
			value += ctn.find('select').val();
		} else if (id.indexOf('no-slider') > -1) {
			value = "no-slider";
		} else if (id.indexOf('slider') > -1) {
			value = "slider";
		}
		
		$(this).addClass('is-processing');

		$.ajax({
			url: "/action/addSiteLabel",
			method: "post",
			data: {
				'key': key,
				'value': value,
				'lang': lang
			},
			success: function (response) {
				if (response.indexOf("success") !== -1) {
					console.log(response);
				}
				location.reload();
			},
			error: function (jqxhr, status, error) {
				console.log(status, error);
			},
			complete: function() {
				$(this).removeClass('is-processing');
			}
		});
	}

	function deleteProperty(e) {
		var t = $(this);
		t.closest('li').slideUp(function() {
			$(this).remove();
		});
	}

	function init() {
		$('.com-suggested-articles__admin input[type="radio"]').on('change', showProperForms);
		$('.com-suggested-articles-admin__submit').on('click', saveProperties);
        $('.com-suggested-articles-admin__form_custom-list').on('click', '.com-suggested-articles-delete-custom-btn', deleteProperty);
	}
	
	$(init);
	
})(jQuery);